module.exports = __webpack_public_path__ + "media/1.40bead21.mp3";